module.exports = __webpack_public_path__ + "img/Trophy Cup Table26.7a2383dd.jpg";